import { Route } from '@angular/router'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type PublicShopsRoutes = {
    publicShops: Route
    publicShopProfile: Route
    publicBookAppointment: Route
}

export const publicShopsRoutes: PublicShopsRoutes = {
    publicShops: {
        path: 'shops',
        loadComponent: () =>
            import('./public-browse-shops/public-browse-shops.component').then(
                (m) => m.PublicBrowseShopsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
        data: {
            title: 'Browse Shops - Hair Style Club',
        },
    },
    publicShopProfile: {
        path: 'shops/:id',
        loadComponent: () =>
            import('./public-shop-profile/public-shop-profile.component').then(
                (m) => m.PublicShopProfileComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
        data: {
            title: 'Shop Profile - Hair Style Club',
        },
    },
    publicBookAppointment: {
        path: 'shops/:shopId/book',
        loadComponent: () =>
            import('./public-book-appointment/public-book-appointment.component').then(
                (m) => m.PublicBookAppointmentComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Public) },
        data: {
            title: 'Book Appointment - Hair Style Club',
        },
    },
}
